module.exports = __webpack_public_path__ + "static/7-7315935c67f2a0edae6af1883109a66a.jpg";